module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-14.f179d924.jpg";